import React, { Component } from "react";
import {
  storyTemplates,
  checkUploadType,
  uploadPreview,
  matchUrl,
  wordFilter,
  createUrlLink,
  createMentionUrl,
  checkValidityForAnonymousToggleCreate,
} from "../../utils/constants";
// import { MentionsInput, Mention } from 'react-mentions'
import defaultCreateStory from "../../pages/stories/defaultCreateStory";
import defaultMobileCreateStory from "../../pages/stories/defaultMobileCreateStory";
import defaultMentionStyle from "../../pages/stories/defaultMentionStyle";
import { Row, Col, Button, Label, ModalHeader, ModalBody } from "reactstrap";
import Toggle from "react-toggle";
import axios from "../../axios";
import * as url from "../../utils/url";
import classnames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { isMobile } from "../../utils/deviceInfo";
import If from "../Shared/If";
import { ReactTinyLink } from "react-tiny-link";
import * as actionCreators from "../../modules/actions/index";
// import ReactPlayer from 'react-player'
import ReactPlayer from "react-player/lazy";
import StoryMentionsText from "./StoryMentionsText";
import Loading from "../../hoc/Loading/Loading";
import UserSearchAndSelectComponent from "../UserSearchAndSelectComponent/UserSearchAndSelectComponent";

class CreateStory extends Component {
  mentionsTextRef = React.createRef();

  constructor(props) {
    super(props);
    const hideAnonymous =
      props.user && props.user.organizationId.disableAnonymity
        ? checkValidityForAnonymousToggleCreate(
            "cultureApp",
            props.user.organizationId.disableAnonymity
          )
        : false;

    this.state = {
      sharedWithUsers: [],
      description: {
        value: "",
      },
      title: "",
      isBadWords: "",
      // urlScrape: false,
      disableCreate: false,
      imageError: null,
      mentionData: [],
      isVideo: false,
      setImagesPreview: [],
      newValue: "",
      rejectedFiles: [],
      ogp: {
        urlScrape: false,
        requestUrl: "",
        // urlScrape:false,
        // ogImage:"",
        // ogDesc:"",
        // ogTitle:"",
        // ogType:"",
        // ogUrl:"",
        // ogSiteName:"",
        // extra:{}
      },
      image: "",
      isListFound: false,
      isListChecked: false,
      isListVisible: true,
      imageUrl: "",
      disableSubmit: true,
      sanitizedDescription: null,
      privacy: "PUBLIC",
      isAnonymous: false,
      isAnonymousVisible: !hideAnonymous,
      mentionsSelected: [],
      mentionsFound: [],
      mentionWord: "",
      topicAlert: false,
      isDescription: null,
      showReplies: false,
      topics: this.props.topics ? this.props.topics : [],
      topicsSelected: [{ name: "All" }],
      storyType: "",
      suggest: [],
      sentiment: null,
    };
  }

  componentDidMount() {
    if (isMobile) {
      this.getTopics();
    }

    let orgId = this.props.user.organizationId._id;

    axios.get(url.getMailer(orgId)).then(({ data }) => {
      this.setState({ isListFound: data.data.listFound });
    });

    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      this.props.orgChangeSuccess(payload);
    });

    //
  }

  getTopics = () => {
    if (!this.props.user) return;
    let orgId = this.props.user.organizationId._id;

    axios.get(url.getTopics(orgId)).then(({ data }) => {
      // console.log("data---", data.data)
      let topics = data.data;
      this.setState({
        topics: [...topics],
      });
    });
  };
  storyTopicSelect = (topic) => {
    let { topicsSelected } = this.state;
    this.setState({ topicAlert: false });
    // console.log(topicsSelected, topic)
    if (topicsSelected.findIndex((x) => x._id === topic._id) > -1) {
      this.setState((prevState) => ({
        topicsSelected: topicsSelected.filter((e) => e._id !== topic._id),
      }));
    } else {
      // console.log("topic----")
      if (topicsSelected.length < 4) {
        this.setState((prevState) => ({
          topicsSelected: [...prevState.topicsSelected, topic],
        }));
      } else {
        this.setState({ topicAlert: true });
      }
    }
  };

  findUrl = (siteUrl) => {
    let httpIndex = siteUrl.indexOf("http");
    let httpString = siteUrl.substr(httpIndex);
    let afterHttp = httpString.indexOf(" ");
    let urlString = siteUrl.substr(httpIndex, afterHttp);
    // console.log(siteUrl, httpIndex, httpString, afterHttp, urlString)
    return urlString;
  };

  sendMentionsText = (textArea) => {
    this.setState({
      ...textArea,
    });
  };

  handleCreateStory = () => {
    let {
      description,
      isAnonymous,
      mentionData,
      sanitizedDescription,
      isListChecked,
      privacy,
      title,
      mentionsSelected,
      topicsSelected,
      ogp,
      setImagesPreview,
      sharedWithUsers,
    } = this.state;

    const formData = new FormData();
    let isUrl, isMention, mentions;

    let cleanDesc = description.value ? wordFilter(description.value) : false;

    if (cleanDesc.length == 0) {
      description.value = createUrlLink(description.value);
      description.value = createMentionUrl(description.value, this.props.user);
      let desc = `<span>${description.value}</span>`;

      if (desc.length > 0) {
        let payload = {
          description: desc,
          title,
          isAnonymous,
          privacy,
          ogp,
          mentionData,
          // sharedWith: sharedWithUsers.map(x => x._id),
        };

        if (sharedWithUsers && sharedWithUsers.length > 0) {
          payload.privacy = "SHARED";
          formData.append("privacy", "SHARED");
          payload.sharedWith = sharedWithUsers.map((x) => ({
            userId: x._id,
            firstName: x.firstName,
            lastName: x.lastName,
            profilePic: x.profilePic,
          }));
          formData.append(
            "sharedWith",
            sharedWithUsers.map((x) => ({
              userId: x._id,
              firstName: x.firstName,
              lastName: x.lastName,
              profilePic: x.profilePic,
            }))
          );
        } else {
          payload.privacy = "PUBLIC";
          formData.append("privacy", "PUBLIC");
          payload.sharedWith = [];
          formData.append("sharedWith", []);
        }

        formData.append("description", desc);
        formData.append("title", title);
        formData.append("mentionData", mentionData);
        formData.append("privacy", privacy);
        formData.append("ogp", ogp);
        formData.append("isCustomList", isListChecked);
        payload.ogp = ogp;
        if (isAnonymous) {
          payload.isAnonymous = isAnonymous;
          formData.append("isAnonymous", isAnonymous);
        } else if (isAnonymous === undefined) {
          payload.isAnonymous = false;
          formData.append("isAnonymous", false);
        }

        if (
          mentionData &&
          mentionData.mentions &&
          mentionData.mentions.length > 0
        ) {
          let { mentions } = mentionData;
          isMention = true;
          sanitizedDescription.userReferences = mentions.map((e) => e.id);
          payload.users = mentions.map((e) => ({
            _id: e.id,
            organizationId: this.props.user.organizationId._id,
          }));
          formData.append("users", mentions);
          payload.mentionsText = mentionData.newValue;
          formData.append("mentionsText", mentionData.newValue);
        }

        if (matchUrl(description.value)) {
          payload.isUrl = true;
          formData.append("isUrl", true);
        }

        // payload.isUrl = isUrl
        // formData.append('isUrl', isUrl);
        payload.isCustomList = isListChecked;

        payload.isMention = isMention;
        formData.append("isMention", isMention);

        payload.sanitizedDescription = sanitizedDescription;
        formData.append("sanitizedDescription", sanitizedDescription);

        payload.template = this.props.storyType;
        formData.append("template", this.props.storyType);
        payload.topics = topicsSelected.filter((e) => e.name != "All");
        formData.append("topics", payload.topics);
        payload.isMobile = isMobile;
        payload.email_text_length = 300

        if (setImagesPreview && setImagesPreview.length > 0) {
          let sorted = setImagesPreview.sort(function(a, b) {
            return b.size - a.size;
          });
          Array.from(sorted).forEach((itm) => {
            delete itm.isAccepted;
            console.log("------------", itm.file);
            formData.append("uploads", itm.file);
          });
        }

        formData.append("isMobile", isMobile);
        formData.append("email_text_length", 300);
        formData.append("payload", JSON.stringify(payload));

        console.log("payload---", payload);

        axios
          .post(url.createStory, formData)
          .then(({ data }) => {
            // console.log(data.data, data.data.data)
            let story = data.data;
            // console.log('story----', story)

            this.props.storyMetricsChange({ type: "story", value: 1 });

            this.setState({ description: "", title: "", topicsSelected: [] });

            story.profilePic = this.props.user.profilePic;
            story = {
              ...story,
              user: this.props.user,
              profilePic: this.props.user.profilePic,
            };
            this.props.onStoryPublish(story);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.setState({ isDescription: "" });
      }
    } else {
      this.setState({ disableCreate: false });

      if (description && description.value && description.value.length == 0) {
        this.setState({ isDescription: "No description" });
      }

      if (cleanDesc && cleanDesc.length > 0) {
        this.setState({ isBadWords: cleanDesc });
      }
    }
  };

  handlePermissionChange = (changeEvent) => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    });
  };

  handleChangeEmailList = (el) => {
    this.setState({
      isListChecked: el.target.checked,
    });
  };

  selectUserMention = (val) => {
    console.log("um_1");
    let name = val.name.replace(/ /g, "_");

    let text = this.state.description.value + name;

    let replaceM = text.lastIndexOf("@") + 1;
    let str1 = text.slice(replaceM);
    let spaceI = str1.indexOf(" ") + 1;
    let diffW = str1.length - name.length;
    let str2 = str1.slice(diffW);
    str1 = str1.slice();

    text = text.replace(str1, str2);
    this.setState((prevState) => ({
      mentionsFound: [],
      mentionWord: "",
      description: { value: text },
      mentionsSelected: [...prevState.mentionsSelected, val],
    }));
  };

  // selectUserMention = (val) => {
  // 	let obj = JSON.parse(val)
  // 	this.setState(prevState => ({
  // 	mentionsFound:[],
  // 	mentionWord:"",
  // 	mentionsSelected: [...prevState.mentionsSelected, obj]
  // 	}))
  // }

  handleImageUpload = ({ target }) => {
    // this.setState({image: event.target.files});
    let image = target.files[0];
    // console.log(image)
    if (image) {
      let imageExt = image.name.split(".")[image.name.split(".").length - 1];
      // console.log(imageExt)
      let imageUrl = URL.createObjectURL(image);

      if (!["png", "jpg", "jpeg"].includes(imageExt.toLowerCase())) {
        this.setState({ imageUrl: "", image: "", imageError: "Not an image" });
      } else if (image.size > 1024 * 1024 * 10) {
        this.setState({
          imageUrl: "",
          image: "",
          imageError: "Image is too big",
        });
      } else {
        this.setState({ image: image, imageUrl: imageUrl, imageError: null });
      }
    }
  };

  removePic = () => {
    this.setState({ image: "", imageUrl: "" });
  };

  removeOgp = () => {
    this.setState({
      ogp: {
        urlScrape: false,
      },
    });
  };

  fetchUsers = (query, callback) => {
    if (!query) return;
    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map((user) => ({
          display: "@" + user.firstName + " " + user.lastName,
          id: `{ "_id": "${user._id}", "email": "${
            user.email
          }", "name": "${user.firstName + " " + user.lastName}"}`,
          // {_id:user._id, email: user.email, idx},
          // name: user.firstName + " " + user.lastName,
          // _id: user._id,
          // email: user.email,
        }))
      )
      .then(callback);
  };

  getFileNameFromS3Path = (path) => {
    // console.log(path)
    if (path !== undefined && path && path !== null) {
      let fileNameArray = path.split("/");
      return fileNameArray[fileNameArray.length - 1];
    }
  };

  returnSiteName = () => {
    let { ogp } = this.state;
    let { ogUrl, twitterAppNameGooglePlay, ogSiteName, requestUrl } = ogp;

    if (ogSiteName) {
      return ogSiteName;
    } else if (twitterAppNameGooglePlay) {
      return twitterAppNameGooglePlay;
    } else {
      let urlName = ogUrl ? ogUrl : requestUrl;
      let startNameURL = urlName.indexOf("w.") + 2;
      let endNameURL = urlName.indexOf(".com");
      let startEndDiff = endNameURL - startNameURL;
      let siteName = urlName.substr(startNameURL, startEndDiff);
      return siteName;
    }
  };

  fileSelectedHandler = (e) => {
    let { setImagesPreview } = this.state;
    this.setState({ imageError: null });
    if (e.target.files) {
      let arr = [];
      let fileArr = Array.from(e.target.files).map((file, idx) => {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          preview: URL.createObjectURL(file),
          isAccepted: checkUploadType(file.type),
        };
        return uploadPreview(obj);
      });

      let acceptedFiles = fileArr.filter((e) => e.isAccepted == true);
      //   .map(e=>{
      // 	delete e.isAccepted
      // 	return e
      //   })
      let rejectedFiles = fileArr.filter((e) => e.isAccepted == false);
      let allUploads = acceptedFiles.concat(rejectedFiles);

      let acceptedLength = setImagesPreview.length + acceptedFiles.length;
      if (acceptedLength < 6) {
        this.setState((prevState) => ({
          setImagesPreview: prevState.setImagesPreview.concat(acceptedFiles),
          rejectedFiles: prevState.rejectedFiles.concat(rejectedFiles),
        }));
        Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
      } else {
        this.setState({
          imageError: 2,
        });
      }
    }
  };

  renderUploadPreview = (source) => {
    let { rejectedFiles } = this.state;
    // if(rejectedFiles && rejectedFiles.length>0){
    //  source = source.concat(rejectedFiles)
    // }

    return source.map((photo, idx) => {
      let { preview, size } = photo;
      let mb = 1024 * 1024;
      let file_size =
        size >= mb
          ? `${(size / mb).toFixed(2)}mb`
          : `${(size / 1024).toFixed(2)}kb`;
      return (
        <span
          key={idx}
          className={
            photo.isAccepted == false
              ? "storyUploadPreviewImg rejectedFilesContainer"
              : "storyUploadPreviewImg"
          }
        >
          {photo.type && photo.type.indexOf("video") > -1 ? (
            <ReactPlayer
              url={preview}
              // controls={true}
              width="125px"
              height="69px"
            />
          ) : (
            <img src={preview} className="fileUploadSize" />
          )}
          <span
            key={preview + idx}
            onClick={() => this.removeImage(photo)}
            className="removeTaskUpload"
          >
            <span className="flaticon-trash" />
          </span>
          <div className="">
            <span className="previewTaskImageTitle">{photo.name}</span>
            <span className="previewTaskImageTitle">{file_size}</span>
            {/* {photo.isAccepted==false?
					<span className="previewUploadFileError">
					  The following file will not be uploaded because of its file type
					</span>
					:null} */}
          </div>
        </span>
      );
    });
  };

  removeImage = (photo) => {
    let { setImagesPreview } = this.state;
    let { preview } = photo;
    setImagesPreview.map((el) => URL.revokeObjectURL(el.file));
    let result = setImagesPreview.filter((e) => e.preview != preview);
    URL.revokeObjectURL(preview);
    URL.revokeObjectURL(photo.file);
    this.setState({ setImagesPreview: result });
  };

  canSubmit = (val) => {
    this.setState({ ...val });
  };

  handleSelectUsers = (users) => {
    this.setState({ sharedWithUsers: [...users] });
  };

 

  render() {
    let {
      description,
      isDescription,
      disableCreate,
      imageError,
      isVideo,
      rejectedFiles,
      setImagesPreview,
      disableSubmit,
      imageUrl,
      topics,
      topicsSelected,
      image,
      isListFound,
      isListChecked,
      isAnonymous,
      ogp,
      sharedWithUsers,
      privacy,
    } = this.state;
    let {
      urlScrape,
      ogImage,
      ogDesc,
      ogTitle,
      ogType,
      ogUrl,
      ogSiteName,
      twitterAppNameGooglePlay,
    } = ogp;
    // console.log(ogp)

    let privacyCheckFailed = false;

    if (this.state.privacy == "SHARED" && this.state.sharedWithUsers && this.state.sharedWithUsers.length == 0) {
     privacyCheckFailed = true
    }

    const disableSubmitButton = disableSubmit || privacyCheckFailed

    const createStoryModalStyle = classnames(
      "profile-modal-save-btn float-left",
      {
        disabled: disableSubmitButton,
        disabledBtn: disableSubmitButton,
        weeklyWinBtn: !isMobile,
        "btn-block": isMobile,
      }
    );


    return (
      <span>
        <If condition={!isMobile}>
          <ModalHeader
            className="createStoryModalHeader"
            charCode="X"
            toggle={this.props.onStoryCancel}
          >
            <div className="weeklyWinTitle pick-office-modal-body-title">
              {this.props.storyType.name}
            </div>
          </ModalHeader>
          {/* <div className="weeklyWinTitle pick-office-modal-body-title">
								{this.props.storyType.name}
							</div> */}
        </If>

        <ModalBody className="create-stories">
          <div className={disableCreate ? "disableCreateStory" : ""}>
            <StoryMentionsText
              canSubmit={this.canSubmit}
              storyType={
                this.props.storyType && this.props.storyType.placeholder
              }
              ref={this.mentionsTextRef}
            />

            {rejectedFiles && rejectedFiles.length > 0 ? (
              <div className="rejectedFilesContainer">
                <span className="">
                  The following file(s) will not be uploaded because of the file
                  type:
                </span>
                &nbsp;
                {rejectedFiles.map((e, idx) => {
                  let name =
                    idx == rejectedFiles.length - 1
                      ? e.name + "."
                      : e.name + ", ";
                  return name;
                })}
              </div>
            ) : null}

            <div>
              {setImagesPreview && setImagesPreview.length > 0 ? (
                <div className="taskUploadPreviewContainer mb0">
                  <div className="taskUploadPreviewContainerOverflow">
                    {this.renderUploadPreview(setImagesPreview)}
                  </div>
                </div>
              ) : null}
            </div>

            <div className="singleTaskUploadModalBtn">
              <label
                htmlFor="profile-pic-file-input"
                style={{ marginBottom: "0px" }}
              >
                <span
                  className={`actionsByStatus singleTaskUpload ${
                    disableCreate ? "opacity40" : ""
                  }`}
                  style={{ color: "white" }}
                >
                  <span className="flaticon-upload" />
                  Upload files
                </span>
              </label>
              <input
                id="profile-pic-file-input"
                onClick={!disableCreate ? this.handleClick : null}
                onChange={this.fileSelectedHandler}
                type="file"
                multiple
              />

              {imageError == 2 ? (
                <span className="errorMsg">
                  Too many files. Max 5 files allowed.
                </span>
              ) : (
                <span className="maxUploadTxt">
                  Attach up to 5 files. Upload any media type (jpg, png, video),
                  office file type (word, excel, csv, powerpoint), and/or pdf.
               
                 <b>(Note* Maximum file size is 20MB)</b> 
                </span>
              )}
            </div>

            <div>
              <Col
                md={12}
                lg={12}
                className={`${isMobile && "pb-150"} pl-0 stories-toggle`}
              >
                <span className="storyTopicsModalTitle">Topics</span>

                {this.state.topicAlert ? (
                  <div className="topicAlert">
                    Please only select 3 topics. To select another topic,
                    deselect one of your current selections
                  </div>
                ) : null}

                {topics && topics.length > 0 ? (
                  <div className="storyTopicsModal">
                    {/* <div className="storyGroupContainer">
																	<div className="storyGroupsModalSelected" >
																				All
																	</div>
															</div> */}

                    {topics.map((topic, idx) => {
                      return (
                        <div
                          className="storyGroupContainer"
                          onClick={() => this.storyTopicSelect(topic)}
                          key={idx}
                        >
                          <div
                            className={
                              topicsSelected.findIndex(
                                (x) => x.name === topic.name
                              ) > -1
                                ? "storyGroupsModalSelected"
                                : "storyGroupsModal"
                            }
                          >
                            {topic.name}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}

                <Row>
                  <Col>
                    <div
                      className="toggle-switch anonymousStory"
                      hidden={!this.state.isAnonymousVisible}
                    >
                      <span className="ml10">
                        <Toggle
                          checked={isAnonymous}
                          icons={false}
                          onChange={this.handlePermissionChange}
                        />
                      </span>
                      <span className="permission-value ml10">Anonymous</span>
                    </div>

                    {isDescription === ""
                      ? "Please include a description"
                      : null}

                    <If condition={isMobile}>
                      <div className="mt-4">
                        {this.state.isBadWords.length > 0 ? (
                          <span className="badwords">
                            {" "}
                            There appears to be a profane or insensitive word in
                            your post:{" "}
                            <strong>{this.state.isBadWords.join(", ")}</strong>.
                            Please remove them and try posting your story again.
                            {/* Please contact us at <a href="mailto:support@ouroffice.io "> support@ouroffice.io </a> if you continue to have a problem. */}
                          </span>
                        ) : null}
                      </div>
                    </If>
                  </Col>
                </Row>

                <div className="mt-5 mb-0 select-shared-with-users">
                  <UserSearchAndSelectComponent
                    selectedUsers={sharedWithUsers}
                    handleSelectUsers={this.handleSelectUsers}
                    label={"Only share with"}
                    privacy={privacy}
                    changePrivacy={(val) => this.setState({ privacy: val })}
                  />
                </div>

                {isListFound != false && this.props.user.orgAdmin ? (
                  <div className="mt40 noPadding">
                    <div className="" hidden={!this.state.isListVisible}>
                      <span className="">
                        <Toggle
                          checked={isListChecked}
                          icons={false}
                          onChange={this.handleChangeEmailList}
                        />
                      </span>
                      <span className="permission-value ml10">
                        Send to custom email list ?
                      </span>
                    </div>
                  </div>
                ) : null}
              </Col>
            </div>

            <div className={`storyModalSubmitContainer`}>
              <If condition={!isMobile}>
                {this.state.isBadWords.length > 0 ? (
                  <span className="badwords">
                    {" "}
                    There appears to be a profane or insensitive word in your
                    post: <strong>{this.state.isBadWords.join(", ")}</strong>.
                    Please remove them and try posting your story again.
                    {/* Please contact us at <a href="mailto:support@ouroffice.io "> support@ouroffice.io </a> if you continue to have a problem. */}
                  </span>
                ) : null}
              </If>
              {this.state.isEditStory ? (
                <Button
                  className="profile-modal-save-btn float-left weeklyWinBtn"
                  onClick={() => this.handleEditStory(this.state.editStory)}
                >
                  <span className="profile-modal-save-btn-txt">
                    {" "}
                    Save Edit
                    <span className="ml10 flaticon-tick"></span>
                  </span>
                </Button>
              ) : (
                <Button
                  className={createStoryModalStyle}
                  onClick={
                    disableSubmitButton != true
                      ? () => this.handleCreateStory()
                      : null
                  }
                >
                  <span className="profile-modal-save-btn-txt">
                    {" "}
                    Publish
                    {!isMobile && <span className="ml10 flaticon-tick"></span>}
                  </span>
                </Button>
              )}
              <If condition={!isMobile}>
                <Button
                  className="profile-modal-cancel-btn float-right weeklyWinBtn"
                  onClick={this.props.onStoryCancel}
                >
                  <span className="profile-modal-cancel-btn-txt">Cancel</span>
                </Button>
              </If>
            </div>
          </div>
        </ModalBody>
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    storyMetricsChange: (data) =>
      dispatch(actionCreators.storyMetricsChange(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(CreateStory, axios)));
